
/* Find Your Fate 2.3 | Remixed campaign-inspired names and unified story hooks */
(function () {
  'use strict';

  const classes = [
    'Barbarian', 'Bard', 'Cleric', 'Druid', 'Fighter', 'Monk',
    'Paladin', 'Ranger', 'Rogue', 'Sorcerer', 'Warlock', 'Wizard'
  ];
  const species = [
    'Aasimar', 'Dragonborn', 'Dwarf', 'Elf', 'Gnome',
    'Goliath', 'Halfling', 'Human', 'Orc', 'Tiefling'
  ];

  // Separate culturally flavored name banks avoid Elven names on Dragonborn.
  // These are fantasy-inspired invented names, not canonical naming rules.
  const names = {
    Aasimar: {
      first: ['Aurel', 'Seraphine', 'Ilyon', 'Caelis', 'Solenne', 'Auren', 'Liora', 'Elyra', 'Azriel', 'Vespera', 'Orien', 'Althea'],
      last: ['Dawnward', 'Starborne', 'Lightwell', 'Radiant', 'Suncrest', 'Brightveil', 'Skywarden', 'Daybreak']
    },
    Dragonborn: {
      first: ['Vharax', 'Kezrith', 'Arkhun', 'Thavax', 'Drazira', 'Rhogar', 'Kharza', 'Vezrak', 'Saryx', 'Krazhan', 'Torvash', 'Zerixa'],
      last: ['Ashscale', 'Emberjaw', 'Stormclaw', 'Ironcrest', 'Flamevein', 'Brasshorn', 'Cinderfang', 'Thunderhide']
    },
    Dwarf: {
      first: ['Brokk', 'Dagna', 'Thrain', 'Hilda', 'Garrik', 'Brynja', 'Ormund', 'Kelda', 'Dorrin', 'Magda', 'Korrin', 'Baldra'],
      last: ['Stonehelm', 'Copperbeard', 'Anvilhand', 'Ironvein', 'Deepdelver', 'Granitefist', 'Oathforge', 'Goldmantle']
    },
    Elf: {
      first: ['Aelith', 'Lethariel', 'Faelor', 'Nimara', 'Theren', 'Ilyndra', 'Caelith', 'Sylvaren', 'Naeris', 'Vaelora', 'Eryndor', 'Liathen'],
      last: ['Moonwhisper', 'Silverbough', 'Starleaf', 'Duskglade', 'Windmere', 'Thornsong', 'Nightpetal', 'Brightbranch']
    },
    Gnome: {
      first: ['Pipkin', 'Nimble', 'Tibbit', 'Brixi', 'Wizzle', 'Tink', 'Merri', 'Fizzik', 'Nib', 'Pippa', 'Quillik', 'Zibba'],
      last: ['Cogwhistle', 'Thimblewick', 'Copperpot', 'Geargleam', 'Muddlefoot', 'Tumblepin', 'Sparkspanner', 'Whirligig']
    },
    Goliath: {
      first: ['Korruk', 'Thalga', 'Varran', 'Makra', 'Dorruk', 'Rokha', 'Kavna', 'Torrek', 'Harka', 'Brennok', 'Orka', 'Gorran'],
      last: ['Cliffbreaker', 'Skystrider', 'Stonecaller', 'Peakwarden', 'Frostshoulder', 'Thunderstep', 'Cloudbreaker', 'Ironstride']
    },
    Halfling: {
      first: ['Perrin', 'Rosie', 'Milo', 'Tansy', 'Willa', 'Bram', 'Dottie', 'Fenn', 'Nell', 'Jory', 'Poppy', 'Ollo'],
      last: ['Goodbarrel', 'Underbough', 'Hilltopple', 'Applebrook', 'Tealeaf', 'Softstep', 'Brindlewick', 'Honeywell']
    },
    Human: {
      first: ['Arden', 'Mira', 'Dorian', 'Rowan', 'Elara', 'Corvin', 'Bryn', 'Seren', 'Kael', 'Tavren', 'Isolde', 'Varek'],
      last: ['Ashford', 'Blackthorn', 'Ravencrest', 'Brightwater', 'Thornfield', 'Emberfall', 'Vale', 'Westbrook']
    },
    Orc: {
      first: ['Ghorza', 'Brakka', 'Durgan', 'Mazka', 'Ruzh', 'Korgha', 'Throkk', 'Vorga', 'Grasha', 'Murg', 'Zharra', 'Drogan'],
      last: ['Ironjaw', 'Ashbreaker', 'Redtusk', 'Stoneblood', 'Grimward', 'Stormfist', 'Blackbanner', 'Warstride']
    },
    Tiefling: {
      first: ['Vex', 'Nymera', 'Zareth', 'Malice', 'Irix', 'Sable', 'Vaelis', 'Ember', 'Ruin', 'Sevrin', 'Calixa', 'Vesper'],
      last: ['Duskwalker', 'Cinderveil', 'Nightbloom', 'Ashenheart', 'Blackflame', 'Hellward', 'Gloamsong', 'Dreadmere']
    }
  };

  // First names and surnames inspired by Dice Dungeons campaign characters.
  // They are separate pools, never locked to their original partners.
  // Half-elf names contribute to both Human and Elf naming pools. Names
  // from unsupported species are placed in suitable fantasy naming pools.
  // This is creative adaptation, not a claim about their original species.
  const campaignNameParts = {
    Aasimar: {
      first: ['Mary', 'Uril', 'Angstrom'],
      last: ['Timelaw']
    },
    Dragonborn: {
      first: ['Mees'],
      last: []
    },
    Dwarf: {
      first: ['Jandarr'],
      last: []
    },
    Elf: {
      first: ['Cyrus', 'Felix', 'Frederick', 'Fritz', 'Brighton',
        'Trixie', 'Danny', 'Samuel', 'Apo', 'Edyrum', "Oom'lout", 'Thalindor'],
      last: ['Lobb', 'Silverdall', 'Leclère', 'Adler-Ringo', 'Chrome',
        'Ellian', 'Strophe', 'Carleth', 'Accentegue', 'Silverscale']
    },
    Gnome: {
      first: [],
      last: []
    },
    Goliath: {
      first: ['Coulton', 'Circumflex'],
      last: ['Holt']
    },
    Halfling: {
      first: [],
      last: []
    },
    Human: {
      first: ['Cyrus', 'Enoch', 'Zeph', 'Abraxas', 'Felix',
        'Frederick', 'Fritz', 'Basil', 'Compass', 'Roland', 'Reo',
        'Khoren', 'Samuel', 'Apo'],
      last: ['Lobb', 'Edmund', 'Baerras', 'Briseadh Domhanda',
        'Silverdall', 'Leclère', 'Rose', 'Wainwright', "De'Janeiro",
        'Kasbarian', 'Ellian', 'Strophe']
    },
    Orc: {
      first: ['Cliff', 'Goretusk', 'Morde', 'Kai'],
      last: ['Sandstone', 'Moonfeather']
    },
    Tiefling: {
      first: ['Abraxas', 'Nicholas'],
      last: ['Phillson']
    }
  };

  // Existing campaign heroes who used a single name may occasionally
  // generate as single-name characters. This does not lock first/last pairs.
  const singleNames = {
    Aasimar: ['Uril', 'Angstrom'],
    Dragonborn: ['Mees'],
    Dwarf: ['Jandarr'],
    Elf: ['Danny'],
    Goliath: ['Circumflex'],
    Human: ['Basil', 'Abraxas'],
    Orc: ['Goretusk'],
    Tiefling: ['Abraxas']
  };

  // 80s Adventures mixes recognizable celebrity-inspired names with
  // exaggerated action-hero and glam-rock surnames. First and last names
  // are drawn independently, so characters are not fixed celebrity copies.
  const retroLastNames = [
    'Glamrock', 'Van Damn', 'Springfield', 'Van Halen', 'Bon Jovi',
    'Stallone', 'Schwarzenegger', 'Hasselhoff', 'Lauper', 'Mercury',
    'Idol', 'Osbourne', 'Jagger', 'Bowie', 'Turner', 'Swayze',
    'Miyagi', 'McFly', 'Balboa', 'Ripley', 'Skywalker',
    'Glamstone', 'Rockwell', 'Radcliffe', 'Steelheart',
    'Thunderwood', 'Starbright', 'Powerstone', 'Goldstar',
    'Nightshade', 'Flashburn', 'Neonvale', 'Stardust',
    'Laserheart', 'Rockerfeller', 'Glitterbomb', 'Thunderkiss',
    'Steelstorm', 'Velvetsteel', 'Moonrocket', 'Starcrusher',
    'Diamondback', 'Firestrike', 'Wildstar', 'Rockfist'
  ];

  const retroHumanFirstNames = [
    'Axel', 'Axl', 'Roxie', 'Roxanne', 'Jett', 'Tiffany', 'Blaze',
    'Cassie', 'Nikki', 'Dex', 'Troy', 'Val', 'Ricky', 'Jess',
    'Stevie', 'Frankie', 'Max', 'Mick', 'Billy', 'Cyndi', 'Madonna',
    'Prince', 'Ozzy', 'Bono', 'Freddie', 'David', 'Michael',
    'Janet', 'Whitney', 'Debbie', 'Joan', 'Pat', 'Boy', 'George',
    'Bruce', 'Rick', 'Dolly', 'Cher', 'Lionel', 'Elton',
    'Corey', 'Molly', 'Winona', 'Sigourney', 'Arnold', 'Sylvester',
    'Patrick', 'Jean-Claude', 'Brooke', 'Heather', 'Kim', 'Samantha',
    'Johnny', 'Sonny', 'Sabrina', 'Raven', 'Ace', 'Star',
    'Riff', 'Rocco', 'Turbo', 'Velvet', 'Electra', 'Diamond'
  ];

  // Cryptid Codex draws from early-20th-century names, suggesting the
  // 1920s mystery, folklore and pulp-adventure era without prescribing a setting.
  // Given names are drawn from common period names; surnames are evocative,
  // not sourced from a popularity ranking. All species use this mode's names.
  const cryptidNames = {
    first: [
      'Arthur', 'Albert', 'Alfred', 'Benjamin', 'Calvin', 'Charles',
      'Chester', 'Clarence', 'Clyde', 'Edgar', 'Edward', 'Ernest',
      'Eugene', 'Frank', 'Frederick', 'George', 'Harold', 'Harry',
      'Henry', 'Howard', 'Jack', 'James', 'Joseph', 'Louis',
      'Oscar', 'Otis', 'Raymond', 'Robert', 'Russell', 'Stanley',
      'Theodore', 'Thomas', 'Walter', 'William',
      'Agnes', 'Alice', 'Beatrice', 'Betty', 'Clara', 'Dorothy',
      'Edith', 'Edna', 'Eleanor', 'Elizabeth', 'Ethel', 'Evelyn',
      'Florence', 'Frances', 'Gladys', 'Hazel', 'Helen', 'Ida',
      'Irene', 'Josephine', 'Lillian', 'Louise', 'Lucille', 'Mabel',
      'Margaret', 'Martha', 'Mary', 'Mildred', 'Opal', 'Pearl',
      'Rose', 'Ruth', 'Thelma', 'Vera', 'Viola', 'Virginia'
    ],
    last: [
      'Abbott', 'Adler', 'Ashcroft', 'Barlow', 'Bennett', 'Bishop',
      'Blackwood', 'Caldwell', 'Carver', 'Calloway', 'Doyle', 'Ellis',
      'Ellsworth', 'Finch', 'Fletcher', 'Graves', 'Hargrove', 'Hart',
      'Hawthorne', 'Hayes', 'Holloway', 'Keller', 'Langley', 'Lockwood',
      'Marlowe', 'Mercer', 'Miller', 'Montgomery', 'Pierce', 'Prescott',
      'Reed', 'Rossi', 'Sinclair', 'Sloane', 'Sterling', 'Sullivan',
      'Talbot', 'Thorne', 'Walker', 'Whitaker', 'Whitcomb', 'Wright'
    ]
  };

  // Retro naming, while retaining species identity.
  const retroNames = {
    Human: ['Roxie', 'Axel', 'Jett', 'Tiffany', 'Blaze', 'Nikki', 'Dex', 'Ricky', 'Stevie', 'Mick', 'Cyndi', 'Madonna', 'Prince', 'Ozzy', 'Bono', 'Freddie', 'Cher', 'Riff', 'Diamond', 'Laser', 'Turbo', 'Glam', 'Ace', 'Rocco'],
    Gnome: ['Zippy', 'Sparky', 'Trix', 'Bop', 'Gizmo', 'Riff'],
    Halfling: ['Sunny', 'Skip', 'Jojo', 'Bobby', 'Penny', 'Teddy'],
    Tiefling: ['Neon', 'Riot', 'Vice', 'Echo', 'Raven', 'Jinx'],
    Dragonborn: ['Blaze', 'Hotshot', 'Turbo', 'Rex', 'Thunder', 'Nitro'],
    Dwarf: ['Ace', 'Diesel', 'Rocky', 'Moxie', 'Brick', 'Hawk'],
    Elf: ['Starlight', 'Flash', 'Echo', 'Glitter', 'Nova', 'Vega'],
    Orc: ['Spike', 'Crash', 'Razor', 'Tank', 'Ruckus', 'Steel'],
    Goliath: ['Hulk', 'Atlas', 'Crusher', 'Thunder', 'Titan', 'Diesel'],
    Aasimar: ['Star', 'Angel', 'Neon', 'Sunny', 'Nova', 'Radiance']
  };

  
const callingByClass = {
  Barbarian: [
    'A battle-rage rises when an old injustice is mentioned.',
    'They carry a broken trophy taken from an undefeated rival.',
    'They once challenged an entire mercenary company to single combat, and nobody accepted.',
    'An old chieftain claims they are the rightful heir to a throne that no longer exists.',
    'They survived a fall from a mountain that should have killed them, but refuse to explain how.',
    'Someone has been placing enormous bounties on their head, though nobody seems to know who wants them.',
    'Their family insists they have never lost a fight, but their oldest friend tells a very different story.',
    'A wandering storyteller claims they once defeated a dragon with nothing but a cooking pot.'
  ],

  Bard: [
    'They know a song that makes strangers remember things that never happened.',
    'They are composing a ballad about a disaster that has not yet occurred.'
  ],

  Cleric: [
    'An unfamiliar holy symbol keeps appearing among their possessions.',
    'Their prayers are sometimes answered by a voice they do not recognize.',
    'A temple has declared them a living saint, despite their repeated objections.',
    'They once performed a miracle in front of hundreds of witnesses, but cannot remember doing it.',
    'A rival religious order claims their divine powers come from a forbidden source.',
    'An ancient prophecy describes someone matching their appearance who will bring about the end of an age.',
    'They have been seen visiting a shrine dedicated to a deity they publicly condemn.',
    'A dying stranger once confessed that their god had specifically warned them about this cleric.'
  ],

  Druid: [
    'Animals go silent whenever they mention a certain place.',
    'They can feel something strange moving through the roots beneath their feet.'
  ],

  Fighter: [
    'They recognize a fighting style from a war no living veteran remembers.',
    'An old scar aches whenever their former commander is near.',
    'A retired general insists they fought beside them in a battle that took place a century ago.',
    'They once defeated a famous champion in a tavern brawl, though the champion denies it ever happened.',
    'A wealthy noble has offered a fortune to anyone who can discover where they learned to fight.',
    'They have never removed a particular piece of armor, even when sleeping.',
    'Their former commanding officer has issued an order for their arrest, but nobody knows the charges.',
    'They are said to possess a weapon that has killed every previous owner.'
  ],

  Monk: [
    'They have sworn never to use a technique taught by their first master.',
    'They were sent away from their order carrying a sealed scroll.'
  ],

  Paladin: [
    'A promise made long ago still governs every choice they make.',
    'They have vowed to defend someone who does not want their protection.',
    'An entire village claims they saved it from destruction, although they have never visited the place.',
    'They once broke a sacred oath to save an innocent life, and someone is still seeking payment for that decision.',
    'Their sword is said to glow in the presence of a particular enemy, though nobody knows who that enemy is.',
    'A powerful noble fears them because of a prophecy that has yet to come true.',
    'They secretly carry a pardon signed by a ruler who has been dead for decades.',
    'A notorious villain refuses to fight them and instead addresses them as an old friend.'
  ],

  Ranger: [
    'Their trail maps contain a valley absent from every other chart.',
    'They keep finding the same impossible tracks in distant wildernesses.'
  ],

  Rogue: [
    'Someone keeps leaving payment for jobs they have never accepted.',
    'They can open a particular lock without remembering where they learned how.',
    'They once stole something so valuable that its owner refuses to admit it existed.',
    'A powerful thieves guild has forbidden its members from speaking their name.',
    'They are rumored to have escaped from an inescapable prison three different times.',
    'A royal investigator believes they are responsible for a series of impossible thefts, but cannot prove a single one.',
    'They possess a key that opens a vault nobody has been able to find.',
    'Several criminals claim to have worked with them, though none agree on what they look like.'
  ],

  Sorcerer: [
    'Their magic briefly changes color when they hear a certain name.',
    'A family heirloom reacts whenever their power gets out of control.'
  ],

  Warlock: [
    'Their patron sometimes speaks through reflections instead of dreams.',
    'The terms of their bargain include one task they cannot remember agreeing to.',
    'A stranger visits them once a year to ask whether they are ready to fulfill their promise.',
    'They have been seen arguing with their own shadow, which appears to be winning.',
    'An ancient book contains their name on a list of people who have not yet been born.',
    'They once offered to sell their soul to a merchant who immediately refused the deal.',
    'A powerful entity has been sending gifts addressed to them under a name they do not recognize.',
    'Every fortune teller who reads their future gives the same warning, then refuses to explain it.'
  ],

  Wizard: [
    'A spell appears in their notes in handwriting they do not recognize.',
    'Their oldest spellbook contains a chapter written tomorrow.',
    'They were expelled from a prestigious magical academy for discovering something the faculty wanted forgotten.',
    'Several powerful wizards insist they are destined to become one of the greatest spellcasters in history, though none will explain why.',
    'An ancient magical artifact responds only to their touch, despite having been created centuries before their birth.',
    'They accidentally invented a spell that another wizard has been taking credit for ever since.',
    'A magical university has offered an enormous reward for the return of a book they claim was stolen by this wizard.',
    'They once lost a magical duel so spectacularly that the location is now considered a historical landmark.'
  ]
};


  const modes = {
    classic: {
      label: 'Classic Fantasy',
      storyTitle: 'Your Story',
      noteTitle: 'A Rumor About You',
      intro: 'A tale of old roads, lost kingdoms, and unlikely heroes.',
      origins: [
        'You grew up among merchants who traded along the border of a forgotten kingdom.',
  'You were raised beside the ruins of a fortress no map remembers.',
  'Your earliest home was a village built around an ancient standing stone.',
  'You spent your youth tending a lighthouse above a dangerous coast.',
  'You learned your trade among wandering performers and adventurers.',
  'You were apprenticed to the keeper of a neglected royal archive.',
  'You spent your childhood in a mountain town famed for its old oaths.',
  'You grew up in a forest settlement where the trees were never cut.',
  'A village elder proclaimed you the chosen one at birth, and you spent your childhood being prepared for a destiny you never asked for.',
  'You were once a celebrated child performer, winning competitions and entertaining nobles, but your fame faded as you grew older.',
  'You were raised within a secretive cult, but fled after discovering the terrifying truth behind its sacred rituals.',
  'Your parents were devoted followers of a powerful religious order, but you abandoned their teachings to find your own path.',
  'You grew up in a quiet farming village, dreaming of legendary heroes and counting the days until you could begin your own adventure.',
  'You were raised to believe that serving your beloved city was the highest honor, and devoted your youth to protecting its people.',
  'You were born into a wealthy noble family but gave up your inheritance rather than accept the life they had planned for you.',
  'You spent years working in a traveling carnival, surrounded by fortune tellers, unusual performers, and people with mysterious pasts.'
      ],
      // Each entry contains the defining event and the reason to adventure.

events: [
  "One winter, a stranger arrived carrying a letter addressed to you in your own handwriting. Now you seek the author of the letter before its final warning comes true.",
  "During a festival, the town bell rang from a tower that had collapsed decades before. You are hunting down the last historian who might know the bell’s secret.",
  "You found a crown hidden inside an ordinary traveler's pack. You hope to learn who hid the crown and why someone wants it back.",
  "A wounded messenger entrusted you with a map made of stitched leather. You are following the courier’s map before the rival hunters catch up.",
  "A creature from an old fireside tale appeared outside your door. You set out to discover what drew the creature out of the old stories.",
  "You discovered that a familiar road led somewhere new after sunset. You are determined to reach that impossible destination once more.",
  "A person you trusted vanished, leaving only a silver key behind. You hope the silver key will lead you to the person who disappeared.",
  "You heard your name whispered from beneath a sealed tomb. You intend to discover whose voice waits beneath the tomb.",

  "You discovered that the mentor who taught you everything was secretly responsible for terrible acts committed in the name of a greater good. You abandoned their teachings and set out to forge your own path, determined not to become like them.",

  "Before settling into your chosen profession, you decided to spend a year traveling as an adventurer. You hope to earn enough gold to start your career while experiencing everything the wider world has to offer.",

  "When a terrible monster attacked your hometown, you somehow managed to defeat it and save everyone. The grateful townsfolk pooled their savings to outfit you as a professional adventurer, and now you fear you may never live up to their expectations.",

  "A beloved family member disappeared just as they were on the verge of accomplishing something extraordinary. You have spent your life living in their shadow, and now you hope to finish what they started or finally make a name for yourself.",

  "Your older brother ruled your homeland with an iron fist, and you led an uprising to overthrow him. The rebellion failed spectacularly, forcing you into exile while your brother's agents continue hunting you.",

  "You trained for years under a renowned vampire hunter, mastering every technique they had to teach. Now you've struck out on your own to continue their work, although you've never actually encountered a vampire and are beginning to wonder if they even exist.",

  "You were personally selected to serve as an agent of the crown, entrusted with carrying out sensitive missions throughout the kingdom. Your latest assignment has taken you far from home, where you must decide how far your loyalty truly extends.",

  "You've never been able to stay in one place for long, always wondering what lies beyond the next hill or across the distant sea. Rather than fight your wanderlust, you've embraced the adventurer's life, collecting stories, friendships, and a few scars along the way.",

  "You inherited a small fortune from a distant relative under one peculiar condition: you must complete a dangerous adventure before you can claim a single coin. What began as an inconvenient obligation has become an opportunity to prove you're capable of more than your family ever expected.",

  "You were once the celebrated champion of a local tournament, undefeated for years until an unknown challenger humiliated you before the entire crowd. Now you travel from town to town, seeking stronger opponents and hoping to become worthy of a rematch.",

  "After being wrongly accused of a crime, you escaped imprisonment with little more than the clothes on your back. You've taken up adventuring under a new identity, hoping to build a life for yourself while gathering the evidence needed to clear your name."
],

      personalities: [
        'Quick with a promise, but slow to forgive a betrayal.',
        'So curious that closed doors feel like personal challenges.',
        'Calm in danger, restless when there is nothing to do.',
        'Suspicious of grand speeches, but loyal to good deeds.',
        'A collector of unlikely friendships and terrible jokes.',
        'Convinced every problem has a clever third option.',
        'Fiercely protective of strangers who remind them of home.',
        'Always ready to wager on the underdog.'
      ],
      quirks: [
        'Keeps keys from doors they have never seen.',
        'Refuses to sleep until every candle is extinguished.',
        'Names every weapon, even borrowed ones.',
        'Leaves a copper coin at abandoned shrines.',
        'Makes sketches of strangers who appear in their dreams.',
        'Can never remember the ending of a particular song.',
        'Collects tiny maps on scraps of parchment.',
        'Always saves a seat for someone who is missing.'
      ]
    },
    mutated: {
      label: 'Mutated Monsters',
      storyTitle: 'Origin File',
      noteTitle: 'Unstable Detail',
      intro: 'A world of bizarre evolution, magical accidents, and dangerous experiments.',
      origins: [
        'You were raised near an abandoned alchemical research outpost.',
        'You were raised by a mad alchemist who called you the "chosen one".',
        'Your family tended a village orchard where the fruit occasionally moved.',
        'You worked as an assistant to a scholar who studied unusual creatures.',
        'You grew up on the edge of a marsh where animals changed overnight.',
        'You spent your childhood among scavengers who salvaged ruined laboratories.',
        'You served as a courier between isolated natural philosophers.',
        'You belonged to a settlement built around a mysterious crater.',
        'You learned survival from hunters who tracked warped beasts.'
      ],
      // Each entry contains the defining event and the reason to adventure.
      events: [
        "A sealed specimen container broke open, and something inside recognized you. You need to learn what escaped before it finds you again.",
        "An animal you once rescued returned with a completely different anatomy. You follow the creature’s trail, hoping to discover what changed it.",
        "You found your name written in a laboratory ledger dated years before your birth. You are searching for the author of the ledger and answers about your past.",
        "A harmless experiment turned the local river an impossible color. You seek the source of the contamination before it spreads downstream.",
        "You saw a creature change shape after drinking from a familiar well. You hope to find a way to reverse the transformation without hurting the creature.",
        "An alchemist offered you a cure for a condition you did not know you had. You are tracking down the alchemist to learn what they knew about you.",
        "A strange new footprint appeared inside a locked room. You are collecting evidence before the locked-room specimen disappears.",
        "A colony of small creatures began copying your gestures perfectly. You intend to discover what the colony wants before it learns anything else."
      ],
      personalities: [
        'Treats every alarming discovery as an excellent research opportunity.',
        'Brave around monsters, nervous around medical equipment.',
        'Keeps meticulous notes and terrible handwriting.',
        'Assumes strange creatures are innocent until proven otherwise.',
        'Easily fascinated by anything with too many eyes.',
        'Distrusts anyone who says an experiment is perfectly safe.',
        'Alternates between scientific precision and wild speculation.',
        'Will stop mid-battle to identify an unfamiliar specimen.'
      ],
      quirks: [
        'Labels every potion bottle, including the empty ones.',
        'Carries a small jar that must never be opened.',
        'Checks the number of fingers on each hand every morning.',
        'Has a pet that nobody can confidently classify.',
        'Sketches the anatomy of monsters on restaurant napkins.',
        'Wears protective gloves even when eating pastries.',
        'Can recognize dozens of unusual animal calls.',
        'Refuses to drink water that glows after dark.'
      ]
    },
    eighties: {
      label: '80s Adventures',
      storyTitle: 'The Origin Montage',
      noteTitle: 'The Plot Twist',
      intro: 'Larger-than-life heroes, rebellious energy, and cinematic trouble.',
origins: [
  'You grew up in a small town where nothing exciting was supposed to happen.',
  'You spent your youth building strange inventions in a cluttered workshop.',
  'You were the new kid at a school with far too many secrets.',
  'You worked late nights at a roadside inn where every traveler seemed to be hiding something.',
  'You practiced every afternoon in a rundown training hall.',
  'You were raised by a former adventurer who never talked about the old days.',
  'You played in a struggling band that rehearsed beneath an abandoned theater.',
  'You spent your evenings at a crowded game hall where competitions were taken far too seriously.',
  'You were discovered alone at a summer camp as a young child and raised by its caretakers, none of whom ever learned where you came from.',
  'During your final years at school, a mysterious killer began hunting your classmates. As one of the few survivors, you devoted yourself to learning how to fight back.',
  'You grew up next door to a retired adventurer who took you under their wing, teaching you everything from self-defense to the importance of standing up for yourself.',
  'Music and wandering performers were outlawed in your hometown, but you grew up practicing in secret, dreaming of the day you could bring music back to its people.',
  'You and your closest childhood friends spent years searching for a legendary treasure rumored to be hidden somewhere beneath your hometown.',
  'You spent much of your youth in trouble with the authorities, eventually finding your closest friends among a group of fellow misfits nobody else seemed to understand.',
  'You grew up in a family where strange physical transformations were considered an ordinary part of coming of age, although you were forbidden from discussing them with outsiders.',
  'You were raised on stories of masked heroes, legendary swordsmen, daring rescues, and impossible romances, and always believed you would someday live an adventure worthy of those tales.',
  'You grew up in a coastal town where a mysterious group of charming outsiders appeared every summer, never seemed to age, and were rarely seen during daylight hours.'
],
      // Each entry contains the defining event and the reason to adventure.

events: [
  "One night, every clock in your hometown stopped a minute before midnight, and when time resumed, an entire year had passed for everyone but you. Unable to return to the life you remembered, you left home to discover what happened and whether you could ever reclaim the time you lost.",

  "You discovered a mysterious glowing artifact inside an old storage chest and accidentally unleashed a power you couldn't control. Although you eventually contained it, the experience awakened a fascination with strange magic and a determination to understand the forces others fear.",

  "You won a prestigious tournament against all expectations, only to discover that the competition had been secretly arranged to identify extraordinary individuals. When powerful strangers began taking an interest in your abilities, you abandoned your comfortable life rather than allow someone else to decide your future.",

  "During a public performance, a mysterious figure interrupted the festivities to deliver a warning meant specifically for you. You dismissed the warning until its prediction came true, and the guilt of ignoring it inspired you to take strange omens and unlikely pleas for help seriously.",

  "Your closest childhood friend vanished during a terrible thunderstorm, and despite weeks of searching, nobody ever discovered what happened. You refused to accept the official explanation and spent the following years developing the skills needed to investigate mysteries that others would rather forget.",

  "You once received a letter from someone claiming to be your future self, describing a terrible mistake you had yet to make. Whether the letter was genuine or an elaborate deception, its warning convinced you to abandon the future everyone expected of you and choose your own destiny.",

  "At a school dance, you stood up to a powerful bully who had terrorized your classmates for years, turning an ordinary celebration into an unforgettable confrontation. Though you barely escaped with your dignity intact, the experience taught you that even the most unlikely hero could inspire others to stand up for themselves.",

  "While exploring your favorite game hall, you discovered a hidden passage leading to forgotten chambers beneath the town. Your discovery sparked an obsession with lost places and ancient secrets, eventually drawing you away from home in search of greater mysteries.",

  "You and your childhood friends discovered an ancient treasure map and embarked on a dangerous expedition to save your hometown from a greedy landowner. Though your friends eventually settled into ordinary lives, you never forgot the thrill of that first adventure and have been chasing it ever since.",

  "When a mysterious figure carried your younger sibling into an enchanted labyrinth, you followed without hesitation and somehow found your way back to the outside world. Your sibling never returned, and the experience left you determined to become strong enough to confront the strange powers that once made you feel helpless.",

  "You once rescued an unusual little creature and were given three simple rules for its care, all of which you managed to break. The resulting disaster nearly destroyed your hometown, leaving you with a lifelong sense of responsibility for the strange creatures and dangerous magic that others underestimate.",

  "You and a group of friends began investigating local hauntings for a little extra money, assuming most supernatural stories were elaborate hoaxes. After a disastrous encounter with a genuinely powerful spirit, you discovered you had a talent for confronting the unknown and decided to put it to better use.",

  "While sheltering from a brutal winter storm, you discovered that one of your traveling companions had been replaced by a creature capable of perfectly imitating anyone. You survived the ordeal, but the experience left you slow to trust strangers and unusually skilled at recognizing the smallest signs of deception.",

  "You once recovered a priceless relic from an ancient temple, only to discover that removing it had awakened a terrible curse. After barely surviving the consequences of your mistake, you devoted yourself to studying lost civilizations and ensuring that dangerous artifacts never fall into careless hands again.",

  "After suffering a humiliating defeat at the hands of a powerful rival, you sought out an eccentric old master who taught you that true strength required patience, discipline, and humility. Your eventual rematch ended differently, but by then you had discovered that becoming a better person mattered more than winning.",

  "You discovered an enchanted storybook describing a distant kingdom slowly being consumed by an endless darkness, only to realize that the places within its pages were real. After helping preserve the kingdom from destruction, you returned home with an unshakable belief that even the most ordinary person could change the course of a great story."
],
      personalities: [
        'Always has a comeback ready, especially when outnumbered.',
        'Treats every problem like the last scene of an action movie.',
        'Recklessly loyal to the friends who stuck around.',
        'Would rather improvise a plan than read the instructions.',
        'Certain that the right soundtrack improves any situation.',
        'Unshakably confident until someone mentions their crush.',
        'Hides real bravery behind relentless sarcasm.',
        'Believes an underdog can win if the training montage is good enough.'
      ],
      quirks: [
        'Carries a potion labeled FOR EMERGENCIES ONLY.',
        'Always wears sunglasses at dramatically inappropriate times.',
        'Keeps a collection of arcade tokens.',
        'Names their signature move before attempting it.',
        'Will not start a quest without checking their hairstyle.',
        'Uses an old walkie-talkie to speak to nobody in particular.',
        'Collects newspaper clippings about unexplained events.',
        'Insists every serious plan needs a montage.'
      ]
    },
    cryptid: {
      label: 'Cryptid Codex',
      storyTitle: 'Field Report',
      noteTitle: 'Unexplained Evidence',
      intro: 'Unexplained sightings, whispered folklore, and clues beyond the firelight.',
origins: [
  'You were raised near an old stretch of forest that locals refused to enter.',
  'Your family ran a roadside stop for travelers with strange stories.',
  'You spent your youth collecting eyewitness accounts in remote settlements.',
  'You worked as a guide in a wilderness known for unexplained disappearances.',
  'You grew up beside a lake where the fishing boats never went after sundown.',
  'You apprenticed with a naturalist whose field notes were always missing pages.',
  'You served as caretaker of an isolated mountain lookout.',
  'You lived in a village where every generation told the same impossible tale.',
  'You grew up in a town plagued by sightings of a mysterious creature in the weeks leading up to a terrible tragedy. The sightings eventually stopped, but the townspeople never agreed on what really happened.',
  'You were found abandoned in the woods as an infant, bearing a strange birthmark unlike anything the local healers had ever seen. Nobody ever discovered who left you there or where you came from.',
  'Your family belonged to a long line of monster hunters, though you grew up wondering how many of their extraordinary stories were actually true.',
  'You were raised in an isolated settlement where the residents left offerings at the edge of the forest every new moon, but nobody would explain what they were meant to appease.',
  'You spent your childhood traveling with a group of performers who made their living exhibiting strange creatures, mysterious artifacts, and supposed wonders from distant lands.',
  'You grew up in a community where children were warned never to answer voices calling from outside their homes after dark, even when those voices sounded familiar.',
  'Your parents devoted their lives to studying an elusive creature rumored to inhabit the surrounding wilderness, and your childhood was filled with expeditions, strange evidence, and unanswered questions.',
  'You were raised in a village where every household kept its doors marked with the same unusual symbol, a tradition so old that nobody remembered what it was supposed to protect them from.'
],
      // Each entry contains the defining event and the reason to adventure.
      events: [
        "A set of enormous tracks appeared overnight, ending in bare stone. You are following the tracks, recording everything before the rain washes them away.",
        "You heard an impossible call from the woods and later heard your own voice answer it. You need to learn why the woods repeated your voice, and what answered it.",
        "A photograph developed to reveal a figure nobody saw at the time. You are searching for the figure in the photograph before the image fades.",
        "A traveler showed you a map of a path that no longer existed. You mean to find the vanished path and discover who removed it.",
        "You witnessed something moving against the wind above the treeline. You now watch the ridgeline every evening, hoping for another glimpse.",
        "A creature left a careful arrangement of stones outside your door. You are recording the stone patterns to learn what the creature is trying to say.",
        "A missing hunter returned carrying a journal written in an unfamiliar hand. You plan to find the hunter’s missing companions and decode the journal.",
        "An entire campsite disappeared, leaving one warm lantern behind. You are searching for the campers, starting with the still-burning lantern."
      ],
      personalities: [
        'Patient with frightened witnesses, impatient with smug skeptics.',
        'Has a healthy fear of the unknown and follows it anyway.',
        'Quietly catalogs every inconsistency in a story.',
        'Never laughs at a local legend, no matter how strange.',
        'Cares more about preserving evidence than winning arguments.',
        'Convinced every mystery has a mundane clue hidden somewhere.',
        'Keeps a calm voice even when the lantern goes out.',
        'Finds wilderness solitude comforting, until it becomes too silent.'
      ],
      quirks: [
        'Measures footprints even when they are obviously ordinary.',
        'Carries a notebook full of sketches no one else can interpret.',
        'Always leaves a little food outside the camp perimeter.',
        'Refuses to whistle in the woods after dark.',
        'Sleeps with a field compass under their pillow.',
        'Collects local newspaper reports of impossible sightings.',
        'Can imitate a call they heard only once.',
        'Keeps one photograph face down in their pack.'
      ]
    }
  };

  const pick = array =>
    array[Math.floor(Math.random() * array.length)];

  function generateName(chosenSpecies, mode) {
    // Human characters in Cryptid Codex use 1920s-inspired names.
    // All other species retain their usual fantasy naming pools.
    if (mode === 'cryptid' && chosenSpecies === 'Human') {
      return pick(cryptidNames.first) + ' ' + pick(cryptidNames.last);
    }

    const bank = names[chosenSpecies] || names.Human;
    const extras = campaignNameParts[chosenSpecies] || { first: [], last: [] };
    const standalone = singleNames[chosenSpecies] || [];

    // Some fantasy characters use just one name. Keep this uncommon,
    // and avoid it for 80s Adventures, which favors cinematic full names.
    if (mode !== 'eighties' && standalone.length && Math.random() < 0.10) {
      return pick(standalone);
    }

    // Independent draws: Enoch can be Edmund, Ashford, Rose, etc.
    // Edmund can pair with any Human first name. No complete-name cameos.
    const first = mode === 'eighties' && chosenSpecies === 'Human'
      ? pick(retroHumanFirstNames)
      : pick([...bank.first, ...extras.first]);
    let last = pick([...bank.last, ...extras.last]);

    if (mode === 'eighties') {
      // Most 80s characters have a larger-than-life surname, regardless of
      // species. Fantasy-species first names stay recognizably fantastical.
      if (Math.random() < 0.85) {
        last = pick(retroLastNames);
      }

      // Human names can stand on their own like a movie credit, or gain a
      // ridiculous wrestling / rock-star nickname. Other species keep their
      // original first name and optionally gain an 80s-style nickname.
      if (chosenSpecies === 'Human') {
        if (Math.random() < 0.34) {
          return first + ' "' + pick(retroNames.Human) + '" ' + last;
        }
        return first + ' ' + last;
      }

      if (Math.random() < 0.68) {
        return first + ' "' + pick(
          retroNames[chosenSpecies] || retroNames.Human
        ) + '" ' + last;
      }
    }

    return first + ' ' + last;
  }

  function generateCharacter(options = {}) {
    const className = classes.includes(options.className)
      ? options.className
      : pick(classes);

    const chosenSpecies = species.includes(options.species)
      ? options.species
      : pick(species);

    const bookMode = Object.prototype.hasOwnProperty.call(
      modes, options.bookMode
    ) ? options.bookMode : 'classic';

    const mode = modes[bookMode];

    const incident = pick(mode.events);

    return {
      name: options.keepName ||
        generateName(chosenSpecies, bookMode),
      className,
      species: chosenSpecies,
      bookMode,
      modeLabel: mode.label,
      modeIntro: mode.intro,
      storyTitle: mode.storyTitle,
      noteTitle: mode.noteTitle,
      origin: pick(mode.origins),
      event: incident,
      // The full event includes its motivation; keep this field for compatibility.
      motivation: '',
      personality: pick(mode.personalities),
      quirk: pick(mode.quirks),
      calling: pick(callingByClass[className])
    };
  }

  window.FindYourFate = {
    generateCharacter,
    characterData: {
      classes,
      species,
      modes
    }
  };
})();
